import { render, staticRenderFns } from "./DocumentComplianceModal.vue?vue&type=template&id=85b6c7b2"
import script from "./DocumentComplianceModal.vue?vue&type=script&lang=js"
export * from "./DocumentComplianceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports